import {
  Box,
  useColorModeValue,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Button,
  useDisclosure,
  Image,
  Card, CardHeader, CardBody, CardFooter,
  Stack,
  Heading,
  Text,
  Divider,
  ButtonGroup,
  VStack,
  SimpleGrid,
  AspectRatio,
} from '@chakra-ui/react';

import { SlideData } from "./projectimages.js";

import { TfiClose } from "react-icons/tfi";
import { ChevronRightIcon } from '@chakra-ui/icons';

import React, { } from "react";
// import ContactInfoGoogleMapsSplit from './ContactInfoGoogleMapsSplit';

//image imports
import plantyp from '../assets/core3_CHL/plan-typ.jpg'
import planground from '../assets/core3_CHL/plan-ground.jpg'
import planroof from '../assets/core3_CHL/plan-roof.jpg'
import plansite from '../assets/core3_CHL/plan-site.jpg'
import rendering_entrance from '../assets/core3_entrance1.png'
import rendering_axoneyelevel from '../assets/core3_entrance2_a5 eye level.png'
import rendering_entrance3 from '../assets/core3_entrance3.png'
import rendering_entrance_anim from '../assets/features_animation.gif'

import rendering_a11 from '../assets/core3_CHL/a11.png'
import rendering_a12_831am from '../assets/core3_CHL/a12_831am.png'
import rendering_c4_1041am from '../assets/core3_CHL/c4_1041am.png'
import rendering_c12 from '../assets/core3_CHL/c12.png'
import rendering_c13 from '../assets/core3_CHL/c13.png'
import rendering_c16_sxnpers from '../assets/core3_CHL/c16_sxn_pers.png'
import rendering_c18adaptive from '../assets/core3_CHL/c18_adaptive.png'
import rendering_1200pm from '../assets/core3_CHL/a1202pm.png'
import rendering_bldgfront37 from '../assets/core3_CHL/bldgfront_Img37_000.png'
import rendering_bldgfront from '../assets/core3_CHL/rendering_a6.png'
import rendering_welcome2 from '../assets/core3_CHL/welcome2.png'
import rendering_a9frontal from '../assets/core3_CHL/a9_frontal.png'

export default ProjectModal;

function ProjectModal() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [size, setSize] = React.useState('md')

  const handleSizeClick = (newSize) => {
    setSize(newSize)
    onOpen()
  }

  // const sizes = ['xs', 'sm', 'md', 'lg', 'xl', 'full']
  // const sizes = ['4xl']
  const sizes = ['full']


  return (
    <>
      {sizes.map((size) => (
        <Button
          onClick={() => handleSizeClick(size)}
          key={size}
          // p={'-4'}
          borderRadius={'lg'}
          border={'1px'}
          textAlign='left'
          fontWeight='bold'
          fontSize={{ base: 'sm', lg: 'sm' }}

          bg={'transparent'}
          _hover={{
            transform: "scale(0.98)",
            transition: 'all .1s ease',
            color: 'gray.500',
            bg: 'transparent'
          }}
          _active={{
            transform: "scale(0.96)",
            transition: 'all .1s ease',
            color: 'gray.800',
          }}
        >
          {/* {`Open ${size} Modal`} */}
          {`Learn More`}
          <ChevronRightIcon boxSize={6}
            // w={8} h={8} 
            color="pink.400" />
        </Button>
      ))}

      <Modal onClose={onClose} size={size} isOpen={isOpen} blockScrollOnMount={false}>
        <ModalOverlay />
        <ModalContent>
          <HStack justify={'flex-end'}>
            <Button onClick={onClose}
              // justify={'space-between'}
              align={'left'}
              _hover={{
                transform: "scale(0.98)",
                transition: 'all .1s ease',
                color: 'gray.500',
                bg: 'transparent'
              }}
              _active={{
                transform: "scale(0.96)",
                transition: 'all .1s ease',
                color: 'gray.800',
              }}
              bg={'transparent'}
            >
              <TfiClose boxSize={24} />
            </Button>
          </HStack>


          <ModalHeader
            fontSize={{ base: '3xl', sm: '4xl' }}
            color={useColorModeValue('black', 'white')}
            fontWeight='thin'
            textAlign='center'

            lineHeight='1'
            mt={"10px"}
            mb={"10px"}
          >
            Intergenerational Urban House Living
            <Text
              letterSpacing={0}
              my={5}
              textAlign='center' fontWeight='light' fontSize={{ base: 'sm', lg: 'sm' }}
              color={useColorModeValue('gray.800', 'gray.200')}
            >
              📍 16 Convent Avenue, New York, NY 10027
            </Text>
          </ModalHeader>
          {/* <ModalCloseButton/> */}

          <ModalBody>
            <Box p={'-4'}>
              {/* <ImageSliderCarousel slides={SlideData} /> */}
              <ProjectGrid />
            </Box>
          </ModalBody>
          {/* <ModalFooter> <Button onClick={onClose}>Close</Button> </ModalFooter> */}
        </ModalContent>
      </Modal>
    </>
  )
}


const ProjectGrid = () => {
  return (
    <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_axoneyelevel}
            alt='Rendering: Axon eye level'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          Entrance from Convent Avenue, New York, NY</Text>
      </VStack>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_entrance_anim}
            alt='Walls'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          Walls</Text>
      </VStack>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_welcome2}
            alt='Welcome'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          Welcome</Text>
      </VStack>

      <VStack>
        <Image
          src={plantyp}
          alt='typical plan'
        />
        <Text
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          Typ. Plan</Text>
      </VStack>

      <VStack>
        <Image
          src={planroof}
          alt='roof plan'
          border='1px' borderColor='gray.300'
        />
        <Text textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          Roof Plan</Text>
      </VStack>

      <VStack>
        <Image
          src={planground}
          alt='ground plan'
          border='1px' borderColor='gray.300'
        />
        <Text textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          Ground Plan</Text>
      </VStack>

      <VStack>
        <Image
          src={plansite}
          border='1px' borderColor='gray.300'
          alt='site plan'
        />
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          Site Plan</Text>
      </VStack>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_bldgfront37}
            alt='Rendering: Building Front'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          Building Front</Text>
      </VStack>
      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_a9frontal}
            alt='Hero shot'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          Exterior</Text>
      </VStack>


      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_entrance3}
            alt='Rendering: Axon eye level'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          Eye Level</Text>
      </VStack>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_entrance}
            alt='Rendering: Entrance'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          Entrance Close-up</Text>
      </VStack>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_bldgfront}
            alt='Rendering: Cafe'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          Building Front Cafe</Text>
      </VStack>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_a11}
            alt='Rendering: Lobby'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          L1 Lobby Garden Facing Convent Avenue</Text>
      </VStack>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_a12_831am}
            alt='Rendering: Lobby'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          L1 Lobby Garden 8:30am</Text>
      </VStack>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_c18adaptive}
            alt='Rendering: Adaptive Reuse'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          L1 Adaptive Reuse Connection to Existing Brick Wall</Text>
      </VStack>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_c4_1041am}
            alt='Rendering: Lobby'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          L2 Kindergarten Seen from L1 Lobby 10:40am</Text>
      </VStack>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_c16_sxnpers}
            alt='Rendering: L2 Kindergarten from L1 Lobby'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          L2 Kindergarten Adjacent to 128st</Text>
      </VStack>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_1200pm}
            alt='L2 Kindergarten Study Space'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          L2 Kindergarten Study Space 12:00pm</Text>
      </VStack>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_c13}
            alt='Rendering: L3 Terrace Common Area'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          L3 Resting Area for Caretakers Watching Over Kindergarteners</Text>
      </VStack>

      <VStack>
        <AspectRatio w={'full'} ratio={1}>
          <Image
            src={rendering_c12}
            alt='Rendering: Roof Level Common Area'
          />
        </AspectRatio>
        <Text
          // size='md'
          textAlign='center'
          fontWeight='light' fontSize={{ base: 'sm', lg: 'md' }}
          color={useColorModeValue('gray.800', 'gray.200')}
        >
          Roof Level Common Area for Building Residents</Text>
      </VStack>

    </SimpleGrid>
  );
};
